import Dynamic1 from '@/assets/images/home/dynamic1.jpg'
import Dynamic2 from '@/assets/images/home/dynamic2.jpg'
import Dynamic3 from '@/assets/images/home/dynamic3.jpg'
import Dynamic4 from '@/assets/images/home/dynamic4.jpg'
import Dynamic5 from '@/assets/images/home/dynamic5.jpg'
import Dynamic6 from '@/assets/images/home/dynamic6.jpg'
import Dynamic7 from '@/assets/images/home/dynamic7.jpg'
import Dynamic8 from '@/assets/images/home/dynamic8.jpg'
import Dynamic9 from '@/assets/images/home/dynamic9.jpg'
import Dynamic11 from "@/assets/images/home/dynamic11.jpg"
import Dynamic10 from "@/assets/images/home/dynamic10.jpg"
import Dynamic12 from "@/assets/images/home/dynamic12.jpg"
import Dynamic13 from "@/assets/images/home/dynamic13.jpg"
import Dynamic14 from "@/assets/images/home/dynamic14.jpg"
import Dynamic15 from "@/assets/images/home/dynamic15.jpg"
import Dynamic16 from "@/assets/images/home/dynamic16.jpg"
import Dynamic17 from "@/assets/images/home/dynamic17.jpg"
import Dynamic18 from "@/assets/images/home/dynamic18.jpg"
import Dynamic19 from "@/assets/images/home/dynamic19.jpg"
import Dynamic20 from "@/assets/images/home/dynamic20.jpg"
import Dynamic21 from "@/assets/images/home/dynamic21.jpg"
import Dynamic22 from "@/assets/images/home/dynamic22.jpg"
import Dynamic23 from "@/assets/images/home/dynamic23.jpg"
import Dynamic24 from "@/assets/images/home/dynamic24.jpg"
import Dynamic25 from "@/assets/images/home/dynamic25.jpg"
import Dynamic26 from "@/assets/images/home/dynamic26.jpg"
import Dynamic27 from "@/assets/images/home/dynamic27.jpg"
import Dynamic28 from "@/assets/images/home/dynamic28.jpg"
import Dynamic29 from "@/assets/images/home/dynamic29.jpg"
import Dynamic30 from "@/assets/images/home/dynamic30.jpg"
import Dynamic31 from "@/assets/images/home/dynamic31.jpg"
import Dynamic32 from "@/assets/images/home/dynamic32.jpg"
import Dynamic33 from "@/assets/images/home/dynamic33.jpg"

const data = [
  {
    index: 32,
    date: '2026.07.31',
    title: '淬炼财务思维，锻造复合型后备人才梯队',
    desc: '7月28日，金融街资本第二期复合应用型后备人才培养计划2026年第三次线下集中培训顺利举行。熙诚教育投资为本次培训提供课程设计与组织实施服务，红鑫领航英才班、红鑫强基先锋班、红鑫铸魂薪火班共有80余名学员参加。...',
    img: Dynamic33
  },
  {
    index: 31,
    date: '2026.07.06',
    title: '淬炼实干底色 激扬国企力量丨2026年西城区属国企优青人才系列培训圆满收官',
    desc: '近日，由西城区国资委主办、熙诚教育投资承办的2026年国企优青干部人才培训班顺利落下帷幕。本次培训自4月28日启动...',
    img: Dynamic32
  },
  {
    index: 30,
    date: '2026.06.22',
    title: '2026年西城区国资委系统积极分子（发展对象）培训班举办：严把党员发展“入口关”，锻造国企后备生力军',
    desc: '6月15日，2026年西城区国资委系统积极分子（发展对象）培训班在新动力金融科技中心举办。...',
    img: Dynamic31
  },
  {
    index: 29,
    date: '2026.06.02',
    title: '对标先进 深学笃行 走进菜百股份参访活动圆满举行',
    desc: '为引导优青干部人才拓宽视野、更新理念，主动借鉴标杆企业的创新机制与管理模式，由西城区国资委主办、熙诚教育投资承办的标杆企业参访——走进菜百股份活动，于5月26日下午举行。 ...',
    img: Dynamic30
  },
  {
    index: 28,
    date: '2026.05.15',
    title: '喜迁新址 聚力启新',
    desc: '为深度扎根西城产业高地、充分发挥国企平台资源整合优势，更好赋能区域产业升级、整合全国优质产业资源、提升公司全域运营服务效能，北京熙诚教育投资有限公司（以下简称“熙诚教育投资”）正式乔迁至——新动力金融科技中心。 ...',
    img: Dynamic29
  },
  {
    index: 27,
    date: '2026.05.08',
    title: '“红色研学——重走五四路”骑行活动顺利举办',
    desc: '为重温革命先辈奋斗历程、锤炼优青干部优良作风，5月7日，西城区国资委举办“红色研学——重走五四路”骑行活动。来自各区属国企的数十位优青骨干参与其中，以骑行方式走访五四运动重要历史地标。 ...',
    img: Dynamic28
  },
  {
    index: 26,
    date: '2026.02.11',
    title: '深耕专业·拓界前行：熙诚教育投资成功举办“4C探界者计划”2025年度优秀案例分享与共创会',
    desc: '2026年2月11日，为系统沉淀组织智慧、激发创新动能、赋能高质量发展，熙诚教育投资于丽泽SOHO隆重举办“4C探界者计划——2025年度优秀案例分享与共创会”。 ...',
    img: Dynamic27
  },
  {
    index: 25,
    date: '2026.02.02',
    title: '洞察“十五五”新格局，锻造新质生产力时代增长韧性——“共生·共谋·共成长”2026企业韧性增长实战论坛在京成功举办',
    desc: '2026年1月30日，由熙诚教育投资主办的“共生·共谋·共成长——2026企业韧性增长实战论坛”在北京丽泽SOHO成功举行。本次论坛聚焦“十五五”新格局 ...',
    img: Dynamic26
  },
  {
    index: 24,
    date: '2025.12.31',
    title: '2025.12.31-2025丨聚势内升',
    desc: '2025年 我们以“聚势内升”为信念，与客户并肩，与团队同心，向内凝聚共识，向上突破边界。这一年，我们聚焦核心业务凝炼产品，发布【2026年度学习赋能计划】。多元内容+多样化全新场景，为客户量身打造“成长操作系统”，让企业的每一次学习都长出利润。 ...',
    img: Dynamic25
  },
  {
    index: 23,
    date: '2025.10.20',
    title: '深化运营谋发展 锤炼团队赢未来｜熙诚教育投资助力广东机场物流锻造高质量管理梯队',
    desc: '为深入贯彻落实集团公司“1236”战略部署，加速构建企业人才高地，广东省机场集团物流有限公司于9月-10月期间系统开展了2025年管理人员运营管理系列培训 ...',
    img: Dynamic24
  },
  {
    index: 22,
    date: '2025.09.17',
    title: '西纳英才、融创未来——西城首届“西融人才”国情研修班圆满收官',
    desc: '为深入学习贯彻习近平总书记关于做好新时代人才工作的重要思想，加快推进高水平人才高地建设，搭建人才跨界交流学习平台 ...',
    img: Dynamic23
  },
  {
    index: 21,
    date: '2025.09.05',
    title: '《AI办公提效》课程走进“国资大讲堂”，助力区属机关单位办公效率提升',
    desc: '近日，由西城区国资委组织、熙诚教育投资老师主讲的“国资大讲堂”系列培训——《AI办公提效》专题课程成功举办。作为区属国有企业 ...',
    img: Dynamic22
  },
  {
    index: 20,
    date: '2025.08.01',
    title: '京港同心向未来——熙诚教育投资助力2025“星动北京·未来之星”实习计划',
    desc: '2025“星动北京·未来之星——香港大学生暑期内地实习计划”正式启动。熙诚教育投资积极响应丰台区“学子回家”行动号召，切实履行国企社会责任 ...',
    img: Dynamic21
  },
  {
    index: 19,
    date: '2025.07.02',
    title: '“党建+业务”双融双促丨《AI办公提效》走进西城区党员教育基地',
    desc: '值此中国共产党成立104周年之际，7月1日上午，由大栅栏街道商会与北京市大碗茶文化发展有限公司党支部联合主办的“西城区红墙先锋工程 ...',
    img: Dynamic20
  },
  {
    index: 18,
    date: '2025.06.24',
    title: '“AI+ ”走进西城企联，DeepSeek助力企业办公提效',
    desc: '6月19日下午，一场聚焦DeepSeek与办公效率提升的行业盛宴在北京锐中心成功举办。由熙诚教育投资主办的《AI办公提效》公开课，吸引了包括中国金币集团 ...',
    img: Dynamic19
  },
  {
    index: 17,
    date: '2025.06.11',
    title: '熙诚教育投资入选成都市中小企业数字化转型服务商',
    desc: '为落实《财政部 工业和信息化部关于开展中小企业数字化转型城市试点工作的通知》(财建〔2023〕117号)文件要求，进一步推进成都市中小企业数字化转型城市试点 ...',
    img: Dynamic18
  },
  {
    index: 16,
    date: '2025.05.21',
    title: '熙诚教育投资 × 腾讯云 | 构建智能知识中枢，赋能咨询服务效率跃升',
    desc: '在行业转型深化与市场竞争加剧的双重挑战下，作为中国咨询培训行业的国企先锋，熙诚教育投资始终以创新驱动发展,聚焦企业管理咨询与学习服务的核心竞争力提升。 ...',
    img: Dynamic17
  },
  {
    index: 15,
    date: '2025.03.21',
    title: '熙诚教育投资助力张一元：以人才破局之势，擘画百年老字号焕新蓝图',
    desc: '春意盎然时节，张一元2025年管理岗位竞聘工作圆满收官。在熙诚教育投资的深度参与下，此次竞聘依托科学测评体系与严谨选拔机制，紧密围绕“双提升” ...',
    img: Dynamic16
  },
  {
    index: 14,
    date: '2025.02.28',
    title: '锻造中流砥柱｜熙诚教育投资携手菜百股份启动“金色工程—金色纽带”，解码核心管理者赋能新范式',
    desc: '人工智能浪潮席卷全球，企业竞争正从“战略之争”转向“组织基因之战”。中层管理者作为战略落地的“关键传动轴”，其能力水平直接影响企业从基因到表达的完整闭环。 ...',
    img: Dynamic15
  },
  {
    index: 13,
    date: '2025.02.25',
    title: '焕新·共赢｜熙诚教育投资与金座公司共建非遗文化研学新生态',
    desc: '在文化自信的时代浪潮中，老字号企业的文化传承与创新发展成为时代的重要课题。2025年2月19日，熙诚教育投资与金座公司一同探讨“教育培训与非遗研学合作交流” ...',
    img: Dynamic14
  },
  {
    index: 12,
    date: '2024-2025',
    title: '喜报！熙诚教育投资获“2024-2025最受企业欢迎培训机构”大奖',
    desc: '日前，由《培训》杂志主办的第十二届中国企业教育培训服务会展圆满落幕，熙诚教育投资凭借深厚的行业积累与创新实力 ...',
    img: Dynamic13
  },
  {
    index: 11,
    date: '2024.11.15',
    title: '熙诚教育投资亮相第13届培博会，斩获2024培博会·培英奖“新锐品牌TOP10”',
    desc: '11月15日，2024培博会·培英奖重磅出炉，熙诚教育投资凭借专业实力与年度卓越表现，在众多企培机构中脱颖而出，荣获2024培博会·培英奖“新锐品牌TOP10” ...',
    img: Dynamic12
  },
  {
    index: 9,
    date: '2024.09.26',
    title: '荣誉时刻|熙诚教育投资荣获第七届年度经济大会“2024中国（行业）创新品牌100强”奖项',
    desc: '凝心聚力同奋进，群贤毕至谋发展，9月26日，2024（第七届）年度经济大会在北京隆重举行。大会以“新质生产力引领经济高质量发展”为主题，吸引了来自政府 ...',
    img: Dynamic11
  },
  {
    index: 10,
    date: '2024.09.10',
    title: '荣誉时刻|熙诚教育投资荣获第三届T20培训咨询行业企业家论坛“最佳合作潜力奖”',
    desc: '9月9日至９月10日，由T20培训机构董事长俱乐部主办的“创新破局·逆势增长：弘扬企业家精神 聚焦高质量发展” ——2024第三届T20培训咨询行业企业家论坛 ...',
    img: Dynamic10
  },
  {
    index: 0,
    date: '2024.07.17',
    title: '辞旧迎新，未来可7丨熙诚教育投资七周年',
    desc: '过去7年里，我们种下真诚和专业。此刻，我们收获了朋友和伙伴。熙诚教育投资七周年，我们跟合作伙伴一起庆祝。过去7年，我们跟中国企业一起成长，彼此成就 ...',
    img: Dynamic1,
    url: 'https://mp.weixin.qq.com/s/H30BKx_AKxy2ENlWuu7zLw'
  },
  {
    index: 1,
    date: '2024.01.08',
    title: '熙诚教育投资积极投身教育公益事业，协办春禾第七期校长研修坊',
    desc: '1月3日至5日，由上海春禾青少年发展中心主办、熙诚教育投资协办的春禾第七期校长研修坊在北京开展，来自全国各地的春禾项目学校校长30余人参加了研修活动 ...',
    img: Dynamic2,
    url: 'https://mp.weixin.qq.com/s/5VCdpYUcE4XQgp_H0XJwkQ'
  },
  {
    index: 2,
    date: '2023.12.08',
    title: '熙诚教育投资携手北大国发院开展承泽企业家圆桌会，探寻中国品牌成长之路',
    desc: '2023年，应时代的新变局和企业家的新需求，北大国发院正式推出了【承泽企业家研修班】，重点培养企业家在新变局时代急需的新思维、新能力 ...',
    img: Dynamic3,
    url: 'https://mp.weixin.qq.com/s/pFBu-FgFo4jOCTa42YL4Tg'
  },
  {
    index: 3,
    date: '2023.12.05',
    title: '荣誉时刻丨熙诚教育投资荣获第15届博奥奖“年度最佳数字化人才赋能服务商”',
    desc: '上个月，由在线教育资讯网（Online-edu）主办的第15届中国企业数智化学习大会（CEFE）在北京隆重举行，大会结合当下热门的人工智能、数字人 ...',
    img: Dynamic4,
    url: 'https://mp.weixin.qq.com/s/v-tjJooSZkkDEaEozbGS5Q'
  },
  {
    index: 4,
    date: '2023.10.25',
    title: '成都高新区国资金融局一行莅临熙诚教育投资座谈交流',
    desc: '10月24日，成都高新区国资金融局党组书记、局长彭涌一行莅临熙诚教育投资指导工作，双方就“资本赋能，共促企业高质量发展”主题进行工作座谈 ...',
    img: Dynamic5,
    url: 'https://mp.weixin.qq.com/s/kIbcZrBU4zMSly7tRJvFjA'
  },
  {
    index: 5,
    date: '2023.09.15',
    title: '产品为王丨光合企学亮相2023企业教育培训博览会！',
    desc: '9月14日至9月15日，新华报业传媒集团《培训》杂志发起的“2023企业教育培训博览会”在深圳大中华喜来登酒店隆重举行。光合企学作为企培行业的优秀代表 ...',
    img: Dynamic6,
    url: 'https://mp.weixin.qq.com/s/qYhSY1VC7J_n7M4yPspeQg'
  },
  {
    index: 6,
    date: '2023.07.31',
    title: '为进一步深化战略合作，熙诚教育投资一行赴雄安新区调研',
    desc: '在广袤的冀中平原，一幅新时代美好的雄安画卷正快速铺展。今天的雄安，正处在如火如荼的建设进行时，并且轮廓已经越来越清晰。7月28日，熙诚教育投资总经理李越 ...',
    img: Dynamic7,
    url: 'https://mp.weixin.qq.com/s/twdQLLcufsjb_QQP2C2uPQ'
  },
  {
    index: 7,
    date: '2023.07.21',
    title: '有为·可为——熙诚教育投资六周年庆圆满落幕',
    desc: '作为企业培训行业的国企先锋，六年来，熙诚教育投资始终坚持以实干笃定前行，聚焦中国企业成长，深耕产品与服务，持续突破创新，谋求企业与客户 ...',
    img: Dynamic8,
    url: 'https://mp.weixin.qq.com/s/n8yUpGZrM3DZBJ5nqIvqDw'
  },
  {
    index: 8,
    date: '2023.06.05',
    title: '深化合作丨雄安管委会领导莅临熙诚教育投资指导交流',
    desc: '2023年6月2日，雄安管委会领导莅临熙诚教育投资指导工作，双方就企业发展话题进行深度交流。今天的雄安新区，经过6年规划建设，已进入大规模建设 ...',
    img: Dynamic9,
    url: 'https://mp.weixin.qq.com/s/F_RJcE_qkdmfJkYnlL07Dw'
  }
]

export default data